interface AppEnv {
  graphqlEndpoint: string;
  irisRealm: string;
  irisUrl: string;
  irisClientId: string;
  appUrl: string;
  isProdBuild: boolean;
}

function read(name: string): string {
  const value = import.meta.env[name];
  return typeof value === 'string' ? value : '';
}

const isProdBuild = import.meta.env.PROD;
export const appEnv: AppEnv = {
  graphqlEndpoint: read('VITE_GRAPHQL_ENDPOINT'),
  irisRealm: read('VITE_IRIS_REALM'),
  irisUrl: read('VITE_IRIS_URL'),
  irisClientId: read('VITE_IRIS_CLIENTID'),
  appUrl: read('VITE_APP_URL'),
  isProdBuild
};
